import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import EcardEditFile from './ECardEditFile';
import { useAppContext } from '../../../../Services/AppContext';
import { useTreatmentContext } from '../../../../Services/TreatmentContext';
import { DocumentationFile } from '../../../../graphql/graphql';

interface Props {
	opened: boolean;
	onClose: any;
	onUpdate?: (folderId: string, needReload: boolean) => void;
	patientId: string;
	params?: any;
	item: DocumentationFile;
}

const ECardEditFileModal: React.FC<Props> = ({
	opened,
	onClose,
	onUpdate,
	patientId,
	item,
}) => {
	const { translation } = useAppContext();
	const { isCase } = useTreatmentContext();

	const onUpdateClose = (folderId: string, needReload: boolean) => {
		onUpdate?.(folderId, needReload);
		onClose();
	};

	return (
		<div>
			<Modal opened={opened} onClose={onClose} wrapChat={isCase}>
				<Modal.Header title={translation['base.shared.editDocument']} />
				<Modal.Content>
					<EcardEditFile
						patientId={patientId}
						onSuccess={onUpdateClose}
						item={item}
					/>
				</Modal.Content>
			</Modal>
		</div>
	);
};

export default ECardEditFileModal;
